import script from "./RescheduleVisit.vue?vue&type=script&setup=true&lang=js"
export * from "./RescheduleVisit.vue?vue&type=script&setup=true&lang=js"

import "./RescheduleVisit.vue?vue&type=style&index=0&id=2f366486&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f366486"]])

export default __exports__